import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SmartphoneCollectService } from '../../../../../services/api-appointment/smartphone-collect/smartphone-collect.service';
import { SmartphoneCollectRequestStatus, SmartphoneCollectStatus } from '../../../../../models/api-appointment/smartphone-collect/smartphone-collect.request.model';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-smartphone-view',
  templateUrl: './smartphone-view.component.html',
  styleUrls: ['./smartphone-view.component.css']
})
export class SmartphoneViewComponent implements OnInit {

  id: number;
  formBuilder: FormGroup;
  goBackUrl: string = "/clickandcollect/smartphone";
  request: any = {};
  isBtnVisibile: boolean = false;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private smartphoneCollectService: SmartphoneCollectService,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,


  ) {
    this.id = this.route.snapshot.params['id'];
    this.initForm();

   }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }

  loadDataByID(idObj) {
    this.spinner.show();
    this.smartphoneCollectService.getEntity(idObj).subscribe(
      (response) => {
        if (response) {
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni della galleria', 'Caricamento galleria', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  initForm() {
    this.formBuilder = this.fb.group({
      name: [""],
      appointmentStatus: [""],
      surname: [""],
      pageUrl: [""],
      telephone: [""],
      email: [""],
      isFastwebCustomer: [""],
      fiscalcode: [""],
      appointmentCode: [""],
      storeCity: [""],
      storeAddress: [""],
      appointmentDate: [""],
      reservationDate: [""],
    });
  }

  getFormValue() {
    let request = new SmartphoneCollectRequestStatus();
    request.appointmentStatus = SmartphoneCollectStatus.COMPLETED;
    return request;
  }

  setFormValue(response) {
    this.formBuilder.controls['appointmentStatus'].setValue(response.appointmentStatus);
    this.formBuilder.controls['surname'].setValue(response.surname);
    this.formBuilder.controls['pageUrl'].setValue(response.pageUrl);
    this.formBuilder.controls['name'].setValue(response.name);
    this.formBuilder.controls['telephone'].setValue(response.telephone);
    this.formBuilder.controls['email'].setValue(response.email);
    this.formBuilder.controls['isFastwebCustomer'].setValue(response.isFastwebCustomer);
    this.formBuilder.controls['fiscalcode'].setValue(response.fiscalcode);
    this.formBuilder.controls['appointmentCode'].setValue(response.appointmentCode);
    this.formBuilder.controls['storeCity'].setValue(response.storeCity);
    this.formBuilder.controls['storeAddress'].setValue(response.storeAddress);
    this.formBuilder.controls['appointmentDate'].setValue(response.appointmentDate);
    this.formBuilder.controls['reservationDate'].setValue(response.reservationDate);
    if (response.appointmentStatus == SmartphoneCollectStatus.CONFIRMED) {
      this.isBtnVisibile = true;
    }
  }

    /**
   * Azione click su button Annulla
   */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.router.navigate([this.goBackUrl]);
  }

  reserveButton() {
    this.request = this.getFormValue();
    this.smartphoneCollectService.changeStatus(this.id, this.request).subscribe(
      (response) => {
        if (response) {
          //Salvata modifica
          this.toastr.success('Status modificato con successo', 'Modifica Status', {
            timeOut: 5000
          });
          this.router.navigate([this.goBackUrl]);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la modifica dello status', 'Modifica Status', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }
}
